import { getSessionCookies } from 'portal-utils/session-cookies'
import { RP_PRIVACY_SETTINGS } from 'portal-modules/common/constants/keys'

export const isCookiesServiceEnabled = serviceItem => {
  let cookiesData = getSessionCookies(RP_PRIVACY_SETTINGS) || {}
  return (
    cookiesData?.enabled_all ||
    (typeof cookiesData?.groups !== 'undefined' &&
      !cookiesData?.groups?.includes(serviceItem))
  )
}
